import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import async from 'async'
import settings from '@/settings'
import {
  clientesDao,
  pessoasDao,
  postosDao,
  ofertasDao,
  combustivelDao,
  codigosPromocionaisDao,
  frentistaDao,
  maquinetaDao,
  formaPagDao,
  versionamentoDao,
  tiposPagamentoDao,
  automacoesDao,
  politicasDePrivacidadeDao,
  termosDeUsoDao,
  propostasDao,
  pagamentosExtra,
  conveniosDao,
  faturamentoDao,
  redesDao,
  empresaDao,
  assinaturaDao,
  compraDao,
  pagPixBankDao,
  coordenadas,
  carteiraVirtualDao,
  itemDao,
  categoriaDao,
  notificacaoDao,
  premioDao,
  provedorSMTPDao,
  sendzapiDao
} from '@/api'

Vue.use(Vuex)

// TODO: Colocar a pessoa como filho do usuario e o endereco como filho da pessoa
export default new Vuex.Store({
  state: {
    frentistas: [],
    maquinetas: [],
    user: null,
    pessoa: null,
    posto: null,
    postos: null,
    combustiveis: [],
    combustiveisSilenciados: {},
    compras: [],
    compras_no_posto: [],
    total_relatorio_compras_no_posto: null,
    total_relatorio_compras: null,
    tiposMaquineta: [],
    tiposPagamento: [],
    vouchers: [],
    total_relatorio_vouchers: null,
    versoes: [],
    faturas: [],
    endereco: null,
    fotoPerfil: null,
    imagemLogo: null,
    loading: false,
    error: null,
    headers: null,
    lastPage: null,
    consolidacao: null,
    automacoes: [],
    automacao: null,
    politicasDePrivacidade: null,
    termosDeUso: null,
    propostas: [],
    recargas_propostas: [],
    pagamentosExtra: [],
    pagamentosSecundarios: [],
    convenios: [],
    clientes: [],
    countCliente: 0,
    verificationId: null,
    timer: 0,
    smartLock: false,
    appVerifier: null,
    interval: 0,
    premios: [],
    redes: [],
    hasNewVersion: false,
    versao: localStorage.getItem(`apetrus-postos-versao`),
    naologar: false,
    solicitacoes_transferencia: [],
    ofertas: [],
    meios_recebimento: [],
    drawer: false
  },
  mutations: {
    setAuthHeader (state, payload) {
      state.headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${payload}`
      })
    },
    clearTimer (state) {
      state.smartLock = false
      state.timer = 0
    },
    decreaseTimer (state, payload) {
      state.timer -= payload
      if (state.timer <= 0) {
        state.timer = 0
        state.smartLock = false
      }
    },
    setTimer (state, payload) {
      state.smartLock = true
      state.timer = payload
    },
    setUser (state, payload) {
      state.user = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setPessoa (state, payload) {
      state.pessoa = payload
    },
    setUserImage (state, payload) {
      state.user.image = payload
    },
    setPostoLogo (state, payload) {
      state.posto.url_logo = payload
    },
    setPostoImagem (state, payload) {
      state.posto.url_imagem_posto = payload
    },
    setEndereco (state, payload) {
      state.endereco = payload
    },
    setFotoPerfil (state, payload) {
      state.fotoPerfil = payload
    },
    setPrecos (state, payload) {
      if (state.posto) {
        state.posto = {
          ...state.posto,
          precos: payload
        }
      }
    },
    setImagemLogo (state, payload) {
      state.imagemLogo = payload
    },
    setPosto (state, payload) {
      state.posto = payload
    },
    setPostos (state, payload) {
      state.postos = payload
    },
    refreshList (state) {
      state.postos = state.postos.map((posto) => {
        if (state.posto.cnpj === posto.cnpj) {
          posto = { ...state.posto }
        }
        return posto
      })
    },
    geolocatePosto (state, payload) {
      state.posto = {
        ...state.posto,
        latitude: payload.lat,
        longitude: payload.lng,
        geoposition: true
      }
    },
    precificarPosto (state, payload) {
      state.posto = {
        ...state.posto,
        precificado: true
      }
    },
    aceitarTermos (state) {
      state.posto = {
        ...state.posto,
        termos_aceitos: true
      }
    },
    insertPosto (state, payload) {
      state.postos.push(payload)
    },
    clearError (state) {
      state.error = null
    },
    setCombustiveis (state, payload) {
      state.combustiveis = payload
    },
    setCombustiveisSilenciados (state, payload) {
      state.combustiveisSilenciados = payload
    },
    changeFrentistas (state, frentista) {
      state.frentistas = [
        ...state.frentistas.map(item => {
          return item.id_frentista !== frentista.id_frentista ? item : frentista
        })
      ]
    },
    changeClientes (state, cliente) {
      state.clientes = [
        ...state.clientes.map(item => item.id_cliente !== cliente.id_cliente ? item : {
          ...item,
          ...cliente
        })
      ]
    },
    changePostos (state, posto) {
      state.posto = { ...state.posto, ...posto }
      state.postos = [
        ...state.postos.map(item => item.cnpj !== posto.cnpj ? item : {
          ...item,
          ...posto
        })
      ]
    },
    setFrentistas (state, payload) {
      state.frentistas = payload
    },
    addFrentista (state, payload) {
      state.frentistas.push(payload)
    },
    setMaquinetas (state, payload) {
      state.maquinetas = payload
    },
    setCompras (state, payload) {
      state.compras = payload
    },
    setTotalRelatorioCompras (state, payload) {
      state.total_relatorio_compras = payload
    },
    setComprasNoPosto (state, payload) {
      state.compras_no_posto = payload
    },
    setTotalRelatorioComprasNoPosto (state, payload) {
      state.total_relatorio_compras_no_posto = payload
    },
    setVouchers (state, payload) {
      state.vouchers = payload
    },
    setTotalRelatorioVouchers (state, payload) {
      state.total_relatorio_vouchers = payload
    },
    setTiposMaquineta (state, payload) {
      state.tiposMaquineta = payload
    },
    setTiposPagamento (state, payload) {
      state.tiposPagamento = payload
    },
    setVersoes (state, payload) {
      state.versoes = payload
    },
    setLastPage (state, payload) {
      if (state.user) {
        localStorage.setItem(`user-${state.user.id}.lastPage`, payload)
      }
      state.lastPage = payload
    },
    removeFrentista (state, payload) {
      let elementoEncontrado = null
      state.frentistas.forEach((element, index) => {
        if (payload.id_frentista === element.id_frentista) {
          elementoEncontrado = index
        }
      })
      if (elementoEncontrado !== null) {
        state.frentistas.splice(elementoEncontrado, 1)
      }
    },
    maquinetaConectada (state, payload) {
      state.posto.maquinetaConectada = payload.id_maquineta
    },
    desconectarMaquineta (state, payload) {
      state.posto.maquinetaConectada = null
    },
    setConsolidacao (state, payload) {
      state.consolidacao = payload
    },
    addSilencioCombustivel (state, payload) {
      state.combustiveisSilenciados[payload.combustivel] = payload
      state.combustiveisSilenciados = {
        ...state.combustiveisSilenciados
      }
    },
    removeSilencioCombustivel (state, payload) {
      state.combustiveisSilenciados[payload.combustivel] = undefined
      state.combustiveisSilenciados = {
        ...state.combustiveisSilenciados
      }
    },
    setAutomacoes (state, payload) {
      state.automacoes = payload
    },
    setAutomacao (state, payload) {
      state.automacao = payload
    },
    setPoliticasDePrivacidade (state, payload) {
      state.politicasDePrivacidade = payload
    },
    setTermosDeUso (state, payload) {
      state.termosDeUso = payload
    },
    setPropostas (state, payload) {
      state.propostas = payload
    },
    setRecargasPropostas (state, payload) {
      state.recargas_propostas = payload
    },
    setPagamentosExtra (state, payload) {
      state.pagamentosExtra = payload
    },
    setPagamentosSecundarios (state, payload) {
      state.pagamentosSecundarios = payload
    },
    setConvenios (state, payload) {
      state.convenios = payload
    },
    setFaturas (state, payload) {
      state.faturas = payload
    },
    setVerificationId (state, payload) {
      state.verificationId = payload
    },
    setAppVerifier (state, payload) {
      state.appVerifier = payload
    },
    setClientes (state, payload) {
      state.clientes = payload
    },
    setPremios (state, payload) {
      state.premios = payload
    },
    setHasNewVersion (state, payload) {
      state.hasNewVersion = payload
    },
    setVersao (state, payload) {
      state.versao = payload
    },
    setRedes (state, payload) {
      state.redes = payload
    },
    setNaologar (state, payload) {
      state.naologar = payload
    },
    setSolicitacoes_transferencia (state, payload) {
      state.solicitacoes_transferencia = payload
    },
    setOfertas (state, payload) {
      state.ofertas = payload
    },
    setCountCliente (state, payload) {
      state.countCliente = payload
    },
    setMeiosRecebimento (state, payload) {
      state.meios_recebimento = payload
    },
    setDrawer (state, payload) {
      state.drawer = payload
    }
  },
  actions: {
    setNaologar ({ commit }, payload) {
      commit('setNaologar', payload)
    },
    toogleCashPosto ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        postosDao.aderirCashPosto(state.posto.cnpj, state.headers).then((response) => {
          if (!response.ok) {
            reject(new Error(response.text))
          }
          return response.json()
        }).then((json) => {
          commit('changePostos', { ...state.posto, tem_cashposto: json })
        })
      })
    },
    toogle24horas ({
      state
    }) {
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        postosDao.update24horas(state.posto.cnpj, state.headers).then((response) => {
          if (!response.ok) {
            reject(new Error(response.text))
          }
          return response.json()
        })
      })
    },
    carregarTiposPos ({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        postosDao.getTiposPagamntosPosPago(state.posto.cnpj, state.headers).then((response) => {
          return response.json()
        }).then((json) => {
          resolve(json)
        })
      })
    },
    toogleTiposPos ({
      commit,
      state
    }, referencia) {
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        tiposPagamentoDao.permitirTipoPagamentoPosPago(state.posto.cnpj, referencia, state.headers).then((response) => {
          if (!response.ok) {
            reject(new Error(response.text))
          }
          return response.json()
        }).then((json) => {
          resolve(json)
        })
      })
    },
    toogleReceberPosPago ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        postosDao.permitirReceberPosPago(state.posto.cnpj, state.headers).then((response) => {
          if (!response.ok) {
            reject(new Error(response.text))
          }
          return response.json()
        }).then((json) => {
          commit('changePostos', { ...state.posto, recebe_pospago: json })
        })
      })
    },
    tooglePlus ({
      commit,
      state
    }, payload) {
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        clientesDao.tornarClientePlus(payload, state.headers).then((response) => {
          if (!response.ok) {
            reject(new Error(response.text))
          }
          return response.json()
        }).then((json) => {
          commit('changeClientes', {
            ...payload,
            cliente_plus: json
          })
          resolve('ok')
        })
      })
    },
    restoreTimer ({
      commit,
      state
    }) {
      if (state.smartLock) {
        commit('setTimer', 60 * 60)
      }
    },
    addTimer ({
      commit,
      state
    }) {
      if (!state.smartLock) {
        commit('setTimer', 60 * 60)
        var interval = setInterval(() => {
          if (state.timer > 0) {
            commit('decreaseTimer', 1)
          } else {
            clearInterval(interval)
          }
        }, 1000)
      }
    },
    clearError ({
      commit
    }) {
      commit('clearError')
    },
    setConsolidacao ({
      commit
    }, payload) {
      commit('setConsolidacao', payload)
    },
    carregarCombustiveis ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        combustivelDao.getCombustiveis().then((response) => {
          return response.json()
        }).then((json) => {
          commit('setCombustiveis', json)
          resolve(json)
        })
      })
    },
    carregarCombustiveisSilenciados ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        combustivelDao.getCombustiveisSilenciados(state.posto.cnpj, state.headers).then((response) => {
          return response.json()
        }).then((json) => {
          async.groupBy(json, function (item, callback) {
            return callback(null, item.combustivel)
          }, (_, groupedJson) => {
            commit('setCombustiveisSilenciados', groupedJson)
            resolve(json)
          })
        })
      })
    },
    meusPostos ({
      commit,
      state
    }) {
      commit('setLoading', true)
      postosDao.meusPostos(state.headers).then((response) => {
        commit('setLoading', false)
        return response.json()
      }).then((json) => {
        let posto = null
        if (json.length === 1) {
          posto = json[0]
        } else {
          let cnpjPosto = localStorage.getItem(`user-${state.user.id}.posto`)
          if (cnpjPosto) {
            posto = json.find((p) => {
              return p.cnpj === cnpjPosto
            })
          }
        }
        this.dispatch('escolherPosto', posto).then(() => {
          commit('setPostos', json)
        })
      })
    },
    escolherPosto ({
      commit,
      state
    }, payload) {
      return new Promise((resolve, reject) => {
        if (!payload) {
          commit('setPosto', payload)
          resolve()
        } else {
          commit('setLoading', true)
          postosDao.detalhar(payload.cnpj, state.headers).then(response => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível detalhar o posto'))
            }
            return response.json()
          }).then(json => {
            commit('setPosto', json)
            if (json.ativo) {
              localStorage.setItem(`user-${state.user.id}.posto`, payload.cnpj)
            }
            resolve()
          })
        }
      })
    },
    geoposicionarPosto ({
      commit
    }, payload) {
      commit('geolocatePosto', payload)
    },
    precificarProdutos ({
      commit
    }, payload) {
      commit('precificarPosto', payload)
    },
    aceitarTermos ({
      commit
    }, payload) {
      commit('aceitarTermos', payload)
    },
    cadastrarPreco ({
      commit,
      state
    }, payload) {
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        combustivelDao.cadastrarPreco(payload, state.headers).then((response) => {
          if (response.ok) {
            resolve()
          } else {
            if (response.status === 422) {
              reject(new Error('O preço na bomba só pode ser alterado uma vez por dia, tente novamente amanhã.'))
            } else {
              reject(new Error('Não foi possível cadastrar preço'))
            }
          }
        })
      })
    },
    cancelarPreco ({
      commit,
      state
    }, payload) {
      if (!state.posto || (state.posto && !state.posto.ativo)) {
        alert('Esse posto está desativado no sistema')
        return
      }
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        combustivelDao.cancelarPreco(payload.id_preco_combustivel, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          resolve(response)
        })
      })
    },
    silenciarCombustivel ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve) => {
        combustivelDao.silenciar(payload.id, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          commit('addSilencioCombustivel', {
            combustivel: payload.id,
            posto: state.posto.cnpj
          })
          resolve(response)
        })
      })
    },
    escutarCombustivel ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve) => {
        combustivelDao.escutar(payload.id, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          commit('removeSilencioCombustivel', {
            combustivel: payload.id
          })
          resolve(response)
        })
      })
    },
    carregarPrecos ({
      commit,
      state
    }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) =>
        combustivelDao.precosPorPosto(state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          return response.json()
        }).then((json) => {
          async.groupBy(json, function (item, callback) {
            return callback(null, item.combustivel.id_combustivel)
          }, (err, groupedJson) => {
            console.log(err)
            let precos = state.combustiveis.map((combustivel) => {
              let precoArray = groupedJson[combustivel.id_combustivel]
              let preco = !!precoArray && precoArray.length ? precoArray[0] : null
              return {
                ...combustivel,
                ...preco
              }
            })
            commit('setPrecos', precos)
            resolve(json)
          })
        })
      )
    },
    listarFrentistas ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        frentistaDao.listaFrentistas(state.posto.cnpj, state.headers)
          .then((response) => {
            if (response.ok) {
              return response.json()
            } else {
              reject(new Error('Não foi possível listar os frentistas!'))
            }
          })
          .then(json => {
            commit('setFrentistas', json)
          })
      })
    },
    carregarVersoes ({
      commit,
      state
    }) {
      versionamentoDao.get(state.headers).then(response => {
        if (response.ok) {
          return response.json()
        }
      }).then(json => {
        commit('setVersoes', json)
      })
    },
    lerVersoes ({
      state
    }) {
      versionamentoDao.ler(state.headers).then(() => {
        this.dispatch('carregarVersoes')
      })
    },
    listarMaquinetas ({
      commit,
      state
    }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        maquinetaDao.getMaquinetas(state.posto.cnpj, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              return response.json()
            } else {
              reject(new Error('Não foi possível listar as Maquinetas!'))
            }
          })
          .then(json => {
            commit('setMaquinetas', json)
          })
      })
    },
    cadastrarMaquineta ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        maquinetaDao.inserirMaquineta(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            return response.json()
          } else {
            // this.confirmação = true
            reject(new Error('Não foi possível salvar a maquineta'))
          }
        }).then(() => {
          this.dispatch('listarMaquinetas')
        })
      })
    },
    conectarMaquinetas ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        maquinetaDao.conectarMaquineta(payload.id_maquineta, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível conctar a maquinetas!'))
          } else {
            commit('maquinetaConectada', payload)
          }
        })
      })
    },
    desconectarMaquinetas ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        maquinetaDao.desconectarMaquineta(payload.id_maquineta, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            commit('desconectarMaquineta', payload)
          } else {
            reject(new Error('Não foi possível desconectar a maquineta!'))
          }
        })
      })
    },
    excluirMaquineta ({
      state,
      commit
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        maquinetaDao.excluirMaquineta(payload, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            this.dispatch('listarMaquinetas')
            resolve(response)
          } else {
            reject(new Error('Não foi possível apagar a maquineta!'))
          }
        })
      })
    },
    inserirHorarioFuncionamento ({
      commit,
      state
    }, horario) {
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        postosDao.cadastrarHorarioFuncionamento(state.posto.cnpj, horario, state.headers).then(response => {
          if (response.ok) {
            return resolve(response)
          } else {
            reject(new Error('Falha ao cadastrar horario'))
          }
        })
      })
    },
    inserirFrentista ({
      commit,
      state
    }, frentista) {
      var body = frentista.id_pessoa ? {
        id_pessoa: frentista.id_pessoa,
        matricula: frentista.matricula
      } : frentista
      body.posto = state.posto.cnpj
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        frentistaDao.inserirFrentista(body, state.headers).then(response => {
          if (response.ok) {
            response.json().then(json => {
              commit('addFrentista', json)
              resolve(json)
            })
          } else {
            response.text().then(e => {
              reject(e)
            })
          }
        })
      })
    },
    removerFrentista ({
      commit,
      state
    }, payload) {
      if (!state.posto || (state.posto && !state.posto.ativo)) {
        alert('Esse posto está desativado no sistema')
        return
      }
      commit('setLoading', true)
      payload.posto = state.posto.cnpj
      frentistaDao.inativarFrentista(state.headers, payload).then((response) => {
        commit('setLoading', false)
        if (!response.ok) {
          if (response.status === 422) {
            commit('setError', {
              message: 'Não possível remover o frentista.'
            })
          }
        } else {
          commit('removeFrentista', payload)
        }
      })
    },
    pinAutenticar ({ commit, state }, pin) {
      return new Promise((resolve, reject) => {
        postosDao.autenticarPin(state.posto.cnpj, pin, state.headers).then((response) => {
          if (!response.ok) {
            reject(new Error('Não foi possível autenticar'))
          } else {
            this.dispatch('addTimer')
            resolve('ok')
          }
        })
      })
    },
    inserirCodigoPromocional ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        codigosPromocionaisDao.inserir(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response)
          } else {
            throw Error()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    inserirCodigoPromocionalConvenio ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          commit('setLoading', false)
          return
        }
        codigosPromocionaisDao.inserirPorConvenio(state.posto.cnpj, payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response)
          } else {
            throw Error()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    cancelarCodigo ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        codigosPromocionaisDao.cancelar(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response)
          } else {
            throw Error()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    cadastrarUsuarioFrentista ({ commit, state }, frentista) {
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        frentistaDao.cadastrarUsuarioFrentista(frentista.id_frentista, { ...frentista, cnpj: state.posto.cnpj }, state.headers).then((response) => {
          if (!response.ok) {
            reject(new Error('Não foi possível cadastrar o usuário'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    consultarFrentistaCPF ({ commit, state }, cpf) {
      return new Promise((resolve, reject) => {
        frentistaDao.verificarPessoa(cpf, state.headers).then((response) => {
          if (!response.ok) {
            reject(new Error('Usuário não existe'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    buscarPropostasDoPosto ({
      commit,
      state
    }, payload) {
      return new Promise((resolve, reject) => {
        propostasDao.buscarPropostasDoPosto(state.headers, state.posto.cnpj, payload)
          .then(res => res.json())
          .then(json => {
            if (payload && payload.has_pagination) {
              commit('setPropostas', json.results)
            } else commit('setPropostas', json)
            resolve(json)
          })
      })
    },
    buscarRecargasPorProposta ({
      commit,
      state
    }, payload) {
      propostasDao.bucarRecargasPorPropostas(payload, state.headers)
        .then(res => res.json())
        .then(json => {
          commit('setRecargasPropostas', json)
        })
    },
    aprovarRecargaProposta ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      propostasDao.aprovarRecarga(payload, state.headers).then(response => {
        commit('setLoading', false)
        if (response.ok) {
          console.log('ok')
        } else {
          commit('setError', {
            message: 'Não foi possível aprovar está recarga'
          })
        }
      })
    },
    unselectPosto ({
      commit,
      state
    }) {
      commit('setPosto', null)
      localStorage.removeItem(`user-${state.user.id}.posto`)
    },
    atualizarLogo ({
      commit,
      state
    }, payload) {
      if (!state.posto || (state.posto && !state.posto.ativo)) {
        alert('Esse posto está desativado no sistema')
        return
      }
      commit('setLoading', true)
      let storageRef = firebase.storage().ref()
      let imageRef = storageRef.child(`postos/logo/${payload.cnpj}.png`)
      imageRef.putString(payload.imagem, 'data_url').then(snapshot => {
        snapshot.ref.getDownloadURL().then(downloadURL => {
          const imagem = {
            url_logo: downloadURL
          }
          commit('setPostoLogo', downloadURL)
          postosDao.atualizarLogoPosto(payload.cnpj, imagem, state.headers)
            .then(res => {
              commit('setLoading', false)
              if (res.ok) {
                commit('setImagemLogo', imagem.url_logo)
                // this.dialogConf = true
              } else {
                commit('setError', {
                  message: 'Não foi possível salvar a imagem de perfil do usuário'
                })
                // this.dialogImagem = true
              }
            })
        })
      })
    },
    atualizarImagemPosto ({
      commit,
      state
    }, payload) {
      if (!state.posto || (state.posto && !state.posto.ativo)) {
        alert('Esse posto está desativado no sistema')
        return
      }
      commit('setLoading', true)
      let storageRef = firebase.storage().ref()
      let imageRef = storageRef.child(`postos/imagem/${payload.cnpj}.png`)
      imageRef.putString(payload.imagem, 'data_url').then(snapshot => {
        snapshot.ref.getDownloadURL().then(downloadURL => {
          const imagem = {
            url_imagem_posto: downloadURL
          }
          postosDao.atualizarImagemPosto(payload.cnpj, imagem, state.headers)
            .then(res => {
              commit('setLoading', false)
              if (res.ok) {
                commit('setPostoImagem', downloadURL)
                // this.dialogConf = true
              } else {
                commit('setError', {
                  message: 'Não foi possível salvar a imagem de perfil do usuário'
                })
                // this.dialogImagem = true
              }
            })
        })
      })
    },
    atualizarBannerPromocional ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)

      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        let storageRef = firebase.storage().ref()
        let imageRef = storageRef.child(`postos/${payload.cnpj}/banners/${payload.promocao}.png`)
        imageRef.putString(payload.imagem, 'data_url').then(snapshot => {
          snapshot.ref.getDownloadURL().then(downloadURL => {
            this.dispatch('ofertas', {
              method: 'PATCH',
              id: payload.promocao,
              parametros: {
                posto: payload.cnpj
              },
              body: {
                url_imagem_promocao: downloadURL
              }
            }).then(() => {
              resolve(downloadURL)
            }).catch(() => {
              commit('setLoading', false)
              reject(new Error('Não foi possível salvar o banner da promoção'))
            })
          })
        })
      })
    },
    inserirBannerStorage ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        let storageRef = firebase.storage().ref()
        let imageRef = storageRef.child(`postos/${state.posto.cnpj}/banners/${payload.prefixo}_${payload.id}.png`)
        imageRef.putString(payload.imagem, 'data_url').then(snapshot => {
          commit('setLoading', false)
          snapshot.ref.getDownloadURL().then(downloadURL => {
            resolve(downloadURL)
          }).catch(error => {
            reject(error)
          })
        })
      })
    },
    atualizarBannerCodigoPromocional ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        let storageRef = firebase.storage().ref()
        let imageRef = storageRef.child(`postos/${payload.cnpj}/banners/codigo_${payload.codigo}.png`)
        imageRef.putString(payload.imagem, 'data_url').then(snapshot => {
          snapshot.ref.getDownloadURL().then(downloadURL => {
            const data = {
              url_imagem_codigo: downloadURL
            }
            codigosPromocionaisDao.atualizar(payload.codigo, data, state.headers, state.posto.cnpj)
              .then(res => {
                commit('setLoading', false)
                if (!res.ok) {
                  commit('setError', {
                    message: 'Não foi possível salvar o banner do código'
                  })
                  reject(new Error('Não foi possível salvar o banner do código'))
                }
                resolve(downloadURL)
              })
          })
        })
      })
    },
    atualizarPerfil ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      pessoasDao.atualizarUsuario(payload, state.headers).then(response => {
        commit('setLoading', false)
        if (response.ok) {
          return response.json()
        } else {
          commit('setError', {
            message: 'Não foi possível atualizar o endereço do usuário'
          })
          return new Error('Não foi possível atualizar o endereço do usuário')
        }
      }).then((json) => {
        commit('setPessoa', json)
      })
    },
    atualizarFotoPerfil ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      let storageRef = firebase.storage().ref()
      let imageRef = storageRef.child(`users/avatars/${payload.id}.png`)
      imageRef.putString(payload.imagem, 'data_url').then(snapshot => {
        snapshot.ref.getDownloadURL().then(downloadURL => {
          const imagem = {
            url_imagem_perfil: downloadURL
          }
          commit('setUserImage', downloadURL)
          pessoasDao.atualizarImagemPerfil(imagem, state.headers)
            .then(res => {
              commit('setLoading', false)
              if (res.ok) {
                commit('setFotoPerfil', imagem.url_imagem_perfil)
                // this.dialogConf = true
              } else {
                commit('setError', {
                  message: 'Não foi possível salvar a imagem de perfil do usuário'
                })
                // this.dialogImagem = true
              }
            })
        })
      })
    },
    atualizarEnderecoPessoa ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      pessoasDao.atualizarEndereco(payload.cadUser, state.headers).then(response => {
        commit('setLoading', false)
        if (response.ok) {
          commit('setEndereco', true)
        } else {
          commit('setError', {
            message: 'Não foi possível atualizar o endereço do usuário'
          })
        }
      })
    },
    atualizarEnderecoPosto ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        postosDao.atualizarEnderecoPosto(state.cnpj, payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            // todo: aterar definição para modelo de promisse
            resolve(true)
            commit('setEndereco', payload)
          } else {
            commit('setError', {
              message: 'Não foi possível atualizar o endereço do posto'
            })
            reject(new Error('Não foi possível atualizar o endereço do posto'))
          }
        })
      })
    },
    atualizarEnderecoPessoaPorPosto ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoasDao.atualizarEnderecoPorPosto(payload.cadUser, state.headers).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            // todo: aterar definição para modelo de promisse
            resolve(true)
            commit('setEndereco', true)
          } else {
            commit('setError', {
              message: 'Não foi possível atualizar o endereço do usuário'
            })
            reject(new Error('Não foi possível atualizar o endereço do usuário'))
          }
        })
      })
    },
    carregarPerfil ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        pessoasDao.auth(state.headers).then(response => {
          if (!response.ok) {
            reject(new Error())
            commit('setError', {
              message: 'Seu usuário não foi encontrado.'
            })
            this.dispatch('signUserOut')
          }
          return response.json()
        }).then(json => {
          commit('setPessoa', json)
          resolve(json)
        })
      })
    },
    redesSociais ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.redeSocial(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            if (payload.method === 'POST') commit('setSuccess', 'Rede social cadastrada com sucesso')
            else if (payload.method === 'DELETE') commit('setSuccess', 'Rede social excluida com sucesso')
            else resolve(response.json())
            resolve('ok')
          } else {
            if (payload.method === 'POST') commit('setError', `Você já cadastrou um ${payload.nome} para seu posto.`)
            else if (payload.method === 'DELETE') commit('setError', 'Não foi possível excluir rede social')
            else commit('setError', 'Não foi possível pegar redes sociais')
          }
        }).catch(error => {
          commit('setLoading', false)
          commit('setError', 'Erro ao realizar operação')
          reject(error)
        })
      })
    },
    cadastroPessoa ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoasDao.insert(payload.cadUser, state.headers).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            if (response.status === 422) {
              throw Error('Desculpe, já possuímos um usuário cadastrado com esse CPF')
            } else {
              throw Error('Falha ao cadastrar pessoa')
            }
          } else {
            // this.step++
            return response.json()
          }
        }).then(json => {
          commit('setPessoa', json)
          resolve(json)
        }).catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          reject(error)
        })
      })
    },
    cadastroPessoaFrentista ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        pessoasDao.insertByPosto(payload.cadUser, state.headers).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Falha ao cadastrar pessoa'))
          } else {
            // this.step++
            return response.json()
          }
        }).then(json => {
          resolve(json)
        }).catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          reject(error)
        })
      })
    },
    cadastroPostoByClient ({
      commit,
      state
    }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        postosDao.inserirByClient(payload.posto, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            if (response.status === 422) {
              commit('setError', {
                message: 'Não possível cadastrar seu posto.'
              })
              reject(Error('Não possível cadastrar seu posto.'))
            }
          } else {
            commit('insertPosto', payload.posto)
            commit('setPosto', payload.posto)
            localStorage.setItem(`user-${state.user.id}.posto`, payload.posto.cnpj)
            this.dispatch('meusPostos')
            resolve('OK')
          }
        })
      })
    },
    atualizarPosto ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        commit('setLoading', false)
        postosDao.atualizarEnderecoPosto(state.posto.cnpj, payload.posto, state.headers).then((response) => {
          if (!response.ok) {
            if (response.status === 422) {
              commit('setError', {
                message: 'Não possível atualizar seu posto.'
              })
            }
            reject(response.status)
          } else {
            commit('setEndereco', payload.posto)
            resolve(response.status)
          }
        })
      })
    },
    atualizarPostoByClient ({
      commit,
      state
    }, payload) {
      if (!state.posto || (state.posto && !state.posto.ativo)) {
        alert('Esse posto está desativado no sistema')
        return
      }
      commit('setLoading', true)
      postosDao.inserirByClient(payload.posto, state.headers).then((response) => {
        commit('setLoading', false)
        if (!response.ok) {
          if (response.status === 422) {
            commit('setError', {
              message: 'Não possível cadastrar seu posto.'
            })
          }
        } else {
          commit('insertPosto', payload.posto)
          commit('setPosto', payload.posto)
          localStorage.setItem(`user-${state.user.id}.posto`, payload.posto.cnpj)
        }
      })
    },
    signUserUp ({
      commit
    }, payload) {
      commit('setLoading', true)
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          (userCred) => {
            if (payload.logar) {
              const user = userCred.user
              const newUser = {
                id: user.uid,
                email: user.email,
                emailVerified: user.emailVerified,
                events: []
              }
              user.getIdToken(true).then(
                token => {
                  commit('setUser', newUser)
                  commit('setAuthHeader', token)
                }
              )

              firebase.auth().currentUser.sendEmailVerification().then(() => {
                commit('setLoading', false)
              }).catch((error) => {
                commit('setLoading', false)
                commit('setError', error)
              })
              // incluir os demais atributos que o usuário pode ter
              // Como postos que administra, perfil de cliente e perfil de frentista
            } else {
              commit('setNaologar', true)
            }
          }).catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    signUserIn ({
      commit
    }, payload) {
      commit('setLoading', true)
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    signUserOut ({
      commit, state
    }) {
      commit('clearTimer')
      commit('setLoading', true)
      firebase.auth().signOut()
        .catch((error) => {
          var errorCode = error.code
          var errorMessage = error.message
          console.log(errorCode)
          console.log(errorMessage)
        })
      clearInterval(state.interval)
    },
    async renovarToken ({ commit, state }) {
      let diference
      var expirationTime
      var issuedAtTime
      if (state.user != null) {
        await firebase
          .auth()
          .currentUser.getIdTokenResult(true)
          .then((result) => {
            expirationTime = Date.parse(result.expirationTime)
            issuedAtTime = Date.parse(result.issuedAtTime)
            diference = (expirationTime - issuedAtTime) / 1000 / 2
            diference = diference.toFixed(0)
          })
        state.interval = setInterval(() => {
          diference--
          if (diference === 0) {
            firebase
              .auth()
              .currentUser.getIdToken(true)
              .then((token) => {
                commit('setAuthHeader', token)
              })
            firebase
              .auth()
              .currentUser.getIdTokenResult(true)
              .then((result) => {
                var expirationTime
                var issuedAtTime
                expirationTime = Date.parse(result.expirationTime)
                issuedAtTime = Date.parse(result.issuedAtTime)
                diference = (expirationTime - issuedAtTime) / 1000 / 2
                diference = diference.toFixed(0)
              })
          }
        }, 1000)
      }
    },
    userChanged ({
      commit
    }, payload) {
      const user = payload
      commit('setLoading', false)
      if (user) {
        const newUser = {
          id: user.uid,
          email: user.email,
          emailVerified: user.emailVerified,
          image: null,
          events: []
        }

        user.getIdToken().then(
          token => {
            commit('setUser', newUser)
            commit('setAuthHeader', token)
            this.dispatch('renovarToken')
            let storage = firebase.storage()
            storage.ref(`users/avatars/${user.uid}.png`).getDownloadURL()
              .then(
                imageUrl => {
                  commit('setUserImage', imageUrl)
                }
              ).catch(
                error => {
                  console.log('erro', error)
                }
              )
            this.dispatch('carregarPerfil')
            let lastpage = localStorage.getItem(`user-${newUser.id}.lastPage`)
            if (lastpage) {
              commit('setLastPage', lastpage)
            }
          }
        )
      } else {
        commit('setUser', null)
        commit('setAuthHeader', null)
        commit('setLastPage', null)
      }
      // incluir os demais atributos que o usuário pode ter
      // Como postos que administra, perfil de cliente e perfil de frentista
    },
    sendVerifyEmail ({
      commit
    }) {
      commit('setLoading', true)
      return new Promise((resolve) => {
        firebase.auth().currentUser.sendEmailVerification().then(response => {
          commit('setLoading', false)
          resolve(response)
        }).catch((error) => {
          commit('setLoading', false)
          commit('setError', error)
        })
      })
    },
    sendResetEmail ({
      commit
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        firebase.auth().sendPasswordResetEmail(payload).then((response) => {
          commit('setLoading', false)
          resolve(response)
        }).catch((error) => {
          commit('setLoading', false)
          commit('setError', error)
          reject(error)
        })
      })
    },
    resetPassword ({
      commit
    }, payload) {
      commit('setLoading', true)
      return new Promise(resolve => {
        firebase.auth().confirmPasswordReset(payload.actionCode, payload.password).then((response) => {
          commit('setLoading', false)
          firebase.auth().signInWithEmailAndPassword(payload.user.email, payload.password)
          resolve(response)
        })
      })
    },
    sendContactMail ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.contact(payload, state.headers).then(function (response) {
          commit('setLoading', false)
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível enviar o email!'))
          }
        })
      })
    },
    carregarTiposMaquineta ({
      commit,
      state
    }) {
      formaPagDao.list(state.headers).then(response => {
        return response.json()
      }).then(json => {
        commit('setTiposMaquineta', json)
      })
    },
    carregarTiposPagamento ({
      commit
    }) {
      tiposPagamentoDao.get().then(response => {
        return response.json()
      }).then(json => {
        commit('setTiposPagamento', json)
      })
    },
    relatorioComprasCallback ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        const pagination = {
          page: 'notPagination'
        }
        postosDao.relatorioCompras(payload, state.posto.cnpj, state.headers, pagination).then(response => {
          commit('setLoading', false)
          return response.json()
        }).then(json => {
          resolve(json.compras)
        }).catch(() => {
          reject(new Error('Não foi possível carregar o relatório de compras'))
        })
      })
    },
    relatorioCompras ({
      commit,
      state
    }, payload) {
      if (!state.posto || (state.posto && !state.posto.ativo)) {
        return
      }
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.relatorioCompras(payload.filtro, state.posto.cnpj, state.headers, payload.pagination).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar compras'))
          }
          return response.json()
        }).then(json => {
          commit('setCompras', json.results.compras)
          commit('setTotalRelatorioCompras', json.results.valor_total)
          commit('setLoading', false)
          resolve(json)
        })
      })
    },
    relatorioComprasNoPosto ({
      commit,
      state
    }, payload) {
      if (!state.posto || (state.posto && !state.posto.ativo)) {
        return
      }
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.relatorioComprasPosto(payload.filtro, state.posto.cnpj, state.headers, payload.pagination).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível carregar compras no posto'))
          }
          return response.json()
        }).then(json => {
          commit('setComprasNoPosto', json.results.compras)
          commit('setTotalRelatorioComprasNoPosto', json.results.valor_total)
          resolve(json)
        })
      })
    },
    relatorioComprasConvenio ({
      commit,
      state
    }, payload) {
      if (!state.posto || (state.posto && !state.posto.ativo)) {
        return
      }
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.relatorioComprasConveio(payload.filtro, state.posto.cnpj, state.headers, payload.pagination).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar compras'))
          }
          return response.json()
        }).then(json => {
          resolve(json)
        })
      })
    },
    relatorioVouchers ({
      commit,
      state
    }, payload) {
      if (!state.posto || (state.posto && !state.posto.ativo)) {
        alert('Esse posto está desativado no sistema')
        return
      }
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        postosDao.relatorioVouchers(payload.filtro, state.posto.cnpj, state.headers, payload.pagination).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar vouchers'))
          }
          return response.json()
        }).then(json => {
          commit('setVouchers', json.results.vouchers)
          commit('setTotalRelatorioVouchers', json.results.valor_total)
          resolve(json)
        })
      })
    },
    relatorioVouchersCallback ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        const pagination = {
          page: 'notPagination'
        }
        postosDao.relatorioVouchers(payload, state.posto.cnpj, state.headers, pagination).then(response => {
          commit('setLoading', false)
          return response.json()
        }).then(json => {
          resolve(json.vouchers)
        }).catch(() => {
          reject(new Error('Não foi possível carregar o relatório de vouchers'))
        })
      })
    },
    saveDataConsolidacaoPagamento ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        postosDao.salvarDadosConsolidacao(payload, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('ok')
          } else {
            throw Error('Desculpe, não foi possível realizar o processo')
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    saveDataConsolidacaoAbastecimento ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        postosDao.salvarDadosConsolidacaoAbastecimento(payload, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('ok')
          } else {
            throw Error('Desculpe, não foi possível realizar o processo')
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getConsolidacoes ({
      commit,
      state
    }, intervalo) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.getConsolidacoes(intervalo, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            return response.json()
          } else {
            throw Error('Desculpe, não foi possível realizar o processo')
          }
        }).then((json) => {
          resolve(json)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    fecharConsolidacaoPagamento ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        postosDao.consolidarPagamento(payload, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('ok')
          } else {
            throw Error('Desculpe, não foi possível realizar o processo')
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    fecharConsolidacaoAbastecimento ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        postosDao.consolidarAbastecimento(payload, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('ok')
          } else {
            throw Error('Desculpe, não foi possível realizar o processo')
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    carregarAutomacoes ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        automacoesDao.list(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          }
          reject(new Error('Não foi possível pegar altomação'))
        })
      })
    },
    selecionarAutomacao ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        automacoesDao.selecionar(payload, state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response)
          } else {
            reject(new Error('Desculpe, não foi possível selecionar a automação'))
          }
        })
      })
    },
    carregarAutomacao (
      {
        commit,
        state
      },
      payload
    ) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        automacoesDao.carregarAutomacao(state.posto.cnpj, state.headers, payload).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          }
          reject(new Error('Não foi possível pegar automação'))
        })
      })
    },
    carregarPoliticasDePrivacidade ({
      commit,
      state
    }) {
      commit('setLoading', true)
      politicasDePrivacidadeDao.get().then(response => {
        commit('setLoading', false)
        if (response.ok) {
          return response.json()
        } else {
          throw Error('Desculpe, não foi possível carregar as políticas de privacidade')
        }
      }).then(json => {
        commit('setPoliticasDePrivacidade', json)
      }).catch(error => {
        commit('setError', error)
      })
    },
    carregarTermosDeUso ({
      commit,
      state
    }) {
      commit('setLoading', true)
      termosDeUsoDao.get().then(response => {
        commit('setLoading', false)
        if (response.ok) {
          return response.json()
        } else {
          throw Error('Desculpe, não foi possível carregar os termos de uso')
        }
      }).then(json => {
        commit('setTermosDeUso', json)
      }).catch(error => {
        commit('setError', error)
      })
    },
    carregarPagamentosExtra ({
      commit,
      state
    }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtra.porPosto(state.headers, state.posto.cnpj).then(response => {
          commit('setLoading', false)
          return response.json()
        }).then(json => {
          commit('setPagamentosExtra', json)
          resolve(json)
        }).catch(error => {
          reject(error)
        })
      })
    },
    carregarPagamentosExtraMatriz ({
      commit,
      state
    },
    payload
    ) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtra.porPosto(state.headers, payload.cnpj).then(response => {
          commit('setLoading', false)
          return response.json()
        }).then(json => {
          resolve(json)
        }).catch(error => {
          reject(error)
        })
      })
    },
    carregarPagamentosSecundarios ({
      commit,
      state
    }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto) {
          commit('setLoading', false)
          reject(Error('Posto não encontrado'))
        }
        pagamentosExtra.secundarioPorPosto(state.headers, state.posto.cnpj).then(response => {
          commit('setLoading', false)
          return response.json()
        }).then(json => {
          commit('setPagamentosSecundarios', json)
          resolve(json)
        }).catch(error => {
          reject(error)
        })
      })
    },
    apagarPagamentoExtra ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        pagamentosExtra.desvincularPagamento(state.headers, payload.pagamento, payload.model).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('Forma de pagamento apagada com sucesso.')
          } else {
            throw new Error('Desculpe, mas a forma de pagamento não pôde ser apagada.')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ativarPagamentoExtra ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        pagamentosExtra.ativarPagamento(state.headers, payload.meio_pagamento, {
          tipo_pagamento: payload.tipo_pagamento,
          posto: state.posto.cnpj
        }, payload.deletar).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response)
          } else {
            reject(response)
          }
        })
      })
    },
    habilitarPagamentoExtra ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        pagamentosExtra.habilitarPagamento(state.headers, payload.meio_pagamento).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response)
          } else {
            reject(response)
          }
        })
      })
    },
    listarConvenios ({
      commit,
      state
    }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        conveniosDao.listar(state.headers, state.posto.cnpj).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            return response.json()
          } else {
            throw new Error('Não foi possível listar seus convênios')
          }
        }).then(json => {
          commit('setConvenios', json)
          resolve(json)
        }).catch(error => {
          commit('setError', error)
          reject(error)
        })
      })
    },
    inserirConvenio ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        commit('setLoading', false)
        conveniosDao.inserir(state.headers, payload, state.posto.cnpj).then(response => {
          if (response.ok) {
            resolve(response.json())
          } else {
            throw new Error('Não foi possível inserir o convênio')
          }
        }).catch(error => {
          commit('setError', error)
          reject(error)
        })
      })
    },
    atualizarConvenio ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        commit('setLoading', false)
        conveniosDao.atualizar(state.headers, state.posto.cnpj, payload.id, payload.data).then(response => {
          if (response.ok) {
            resolve(response)
          } else {
            throw new Error('Não foi possível atualizar o convênio')
          }
        }).catch(error => {
          commit('setError', error)
          reject(error)
        })
      })
    },
    removerConvenio ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        commit('setLoading', false)
        conveniosDao.apagar(state.headers, state.posto.cnpj, payload).then(response => {
          if (response.ok) {
            resolve(response)
          } else {
            throw new Error('Não foi possível remover o convênio')
          }
        }).catch(error => {
          commit('setError', error)
          reject(error)
        })
      })
    },
    listarFaturas ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        faturamentoDao.list(payload, state.posto.cnpj, state.headers).then(response => {
          commit('setLoading', false)
          return response.json()
        }).then(json => {
          commit('setFaturas', json)
        })
      })
    },
    detalhesFatura ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        faturamentoDao.info(payload, state.posto.cnpj, state.headers).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            return response.json()
          } else {
            reject(response)
          }
        }).then(json => {
          resolve(json)
        })
      })
    },
    sendSmsVerification ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      commit('setAppVerifier', new firebase.auth.RecaptchaVerifier(payload, {
        'size': 'invisible'
      }))
      var provider = new firebase.auth.PhoneAuthProvider()
      let phoneNumber = state.pessoa.telefone.startsWith('+55') ? state.pessoa.telefone : `+55${state.pessoa.telefone}`
      return new Promise((resolve, reject) => {
        provider.verifyPhoneNumber(phoneNumber, state.appVerifier).then(verificationId => {
          commit('setLoading', false)
          commit('setVerificationId', verificationId)
          resolve(verificationId)
        }).catch(error => {
          console.log(error)
          commit('setLoading', false)
          reject(error)
        })
      })
    },
    confirmSmsVerification ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      var phoneCredential = firebase.auth.PhoneAuthProvider.credential(state.verificationId, payload)
      return new Promise((resolve, reject) => {
        if (firebase.auth().currentUser.phoneNumber) {
          firebase.auth().currentUser.reauthenticateAndRetrieveDataWithCredential(phoneCredential).then((user) => {
            commit('setLoading', false)
            resolve(user)
          }).catch(error => {
            commit('setLoading', false)
            reject(error)
          })
        } else {
          firebase.auth().currentUser.updatePhoneNumber(phoneCredential).then(() => {
            commit('setLoading', false)
            resolve(true)
          }).catch(error => {
            commit('setLoading', false)
            reject(error)
          })
        }
      })
    },
    meusClientes ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        clientesDao.meusClientes(state.headers, payload).then(response => {
          return response.json()
        }).then((json) => {
          commit('setCountCliente', json.count)
          commit('setClientes', json.results)
          resolve(json)
        }).catch(() => {
          reject(new Error('Não foi possível encontrar clientes para esse posto'))
        })
      })
    },
    enviarEmail ({ state }, payload) {
      return new Promise((resolve, reject) => {
        pessoasDao.enviarEmailParaClientes(payload, state.headers).then(response => {
          if (response.ok) {
            resolve('ok')
          }
          reject(new Error('Não foi possível enviar e-mail'))
        }).catch(() => {
          reject(new Error('Não foi possível enviar e-mail'))
        })
      })
    },
    exportarCompras ({ state }, params) {
      return new Promise((resolve, reject) => {
        postosDao.exportarCompras(state.headers, params)
          .then(response => {
            if (!response.ok) {
              reject(new Error('Erro ao exportar compras'))
            } else {
              return response.blob()
            }
          })
          .then(blob => {
            const url = window.URL.createObjectURL(blob)

            let cnpj = params.posto || 'desconhecido'
            cnpj = cnpj.replace(/\D/g, '')

            const filename = `relatorio_compras_${cnpj}.xlsx`

            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link.remove()
            resolve()
          })
          .catch(err => reject(err))
      })
    },
    pushNotification ({ state }, payload) {
      return new Promise((resolve, reject) => {
        notificacaoDao.pushNotification(payload, state.posto.cnpj, state.headers).then(response => {
          if (response.ok) {
            resolve('ok')
          }
          reject(new Error('Não foi possível enviar motificação'))
        }).catch(() => {
          reject(new Error('Não foi possível enviar motificação'))
        })
      })
    },
    fidelidadePosto ({ state }) {
      return new Promise((resolve, reject) => {
        postosDao.fidelidadePosto(state.posto.cnpj, state.headers).then(response => {
          if (!response.ok) {
            reject(new Error('Não foi possível ativar programa'))
          } else {
            this.dispatch('escolherPosto', { cnpj: state.posto.cnpj })
            resolve('OK')
          }
        })
      })
    },
    cadastrarPremio ({ state }, payload) {
      return new Promise((resolve, reject) => {
        postosDao.cadastrarPremio(payload, state.posto.cnpj, state.headers).then(response => {
          if (!response.ok) {
            reject(new Error('Não foi possível cadastrar prêmio'))
          }
          resolve(response.json())
        })
      })
    },
    deletarPremio ({ state }, payload) {
      return new Promise((resolve, reject) => {
        postosDao.deletarPremio(payload, state.posto.cnpj, state.headers).then(response => {
          if (response.ok) {
            resolve('ok')
          }
          reject(new Error('Não foi possível deletar prêmio'))
        })
      })
    },
    pegarPremios ({ state, commit }) {
      return new Promise((resolve, reject) => {
        postosDao.pegarPremios(state.posto.cnpj, state.headers).then(response => {
          return response.json()
        }).then((json) => {
          commit('setPremios', json)
          resolve(json)
        }).catch(() => {
          reject(new Error('Não foi possível encontrar prêmios'))
        })
      })
    },
    inserirImgaemPremio ({ state }, payload) {
      return new Promise((resolve, reject) => {
        postosDao.inserirImagemPremio(payload, state.posto.cnpj, state.headers).then(response => {
          if (response.ok) {
            resolve('ok')
          }
          reject(new Error('Não foi possível inserir imagem'))
        })
      })
    },
    verificarAtualizacao ({ state, commit }, payload) {
      var version = localStorage.getItem(`${payload.name}-versao`)
      if (version !== payload.version) {
        commit('setHasNewVersion', true)
      }
    },
    // Com essa função é possível inserir qualquer tipo de arquivo "referente ao posto" no local desejado (Não alterar)
    inserirArquivoFirebase ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto || (state.posto && !state.posto.ativo)) {
          reject(new Error('Esse posto está desativado no sistema'))
          return
        }
        let storageRef = firebase.storage().ref()
        let imageRef = storageRef.child(`postos/${state.posto.cnpj}/${payload.local}/${payload.prefixo}_${payload.id}.${payload.tipo}`)
        imageRef.putString(payload.arquivo, 'data_url').then(snapshot => {
          commit('setLoading', false)
          snapshot.ref.getDownloadURL().then(downloadURL => {
            resolve(downloadURL)
          }).catch(error => {
            reject(error)
          })
        })
      })
    },
    inserirComprovante ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        faturamentoDao.inserirComprovante(payload, state.posto.cnpj, state.headers).then(response => {
          if (!response.ok) {
            reject(new Error('Não foi possível atualizar fatura'))
          }
          resolve('ok')
        })
      })
    },
    solicitacoesConvenio ({ state, commit }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        conveniosDao.solicitacoesConvenio(state.headers, state.posto.cnpj).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível atualizar fatura'))
          }
          resolve(response.json())
        })
      })
    },
    aceitarSolicitacao ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        conveniosDao.aceitarSolicitacao(state.headers, state.posto.cnpj, payload).then(res => {
          commit('setLoading', false)
          if (!res.ok) {
            reject(new Error('Não foi possível enviar solicitação'))
          }
          resolve('ok')
        })
      })
    },
    relatorioPremios ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto) {
          return
        }
        postosDao.relatorioPremios(payload.filtro, state.posto.cnpj, state.headers, payload.pagination).then(response => {
          commit('setLoading', false)
          resolve(response.json())
        }).catch(() => {
          reject(new Error('Não foi possível carregar relatório'))
        })
      })
    },
    relatorioCash ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto) {
          return
        }
        postosDao.relatorioCash(payload.filtro, state.posto.cnpj, state.headers, payload.pagination).then(response => {
          commit('setLoading', false)
          resolve(response.json())
        }).catch(() => {
          reject(new Error('Não foi possível carregar relatório'))
        })
      })
    },
    pegarRedes ({ commit, state }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        redesDao.pegarRedes(state.headers).then(response => {
          commit('setLoading', false)
          return response.json()
        }).then(json => {
          commit('setRedes', json)
          resolve(json)
        }).catch(() => {
          commit('setLoading', false)
          reject(new Error('Não foi possível pegar redes'))
        })
      })
    },
    postosSemRede ({ commit, state }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        redesDao.postosSemRede(state.headers).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          }
        }).catch(() => {
          commit('setLoading', false)
          reject(new Error('Não foi possível pegar redes'))
        })
      })
    },
    postosDaRede ({ commit, state }, id) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        redesDao.postosDaRede(state.headers, id).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          }
        }).catch(() => {
          reject(new Error('Não foi possível pegar postos sem rede'))
        })
      })
    },
    cadastrarRede ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redesDao.cadastrar(state.headers, payload).then(response => {
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Não foi possível cadastrar rede'))
          }
        })
      })
    },
    atualizarRede ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redesDao.atualizar(state.headers, payload).then(response => {
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível cadastrar rede'))
          }
        })
      })
    },
    inserirEmRede ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redesDao.inserirEmRede(state.headers, payload).then(response => {
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível inserir postos na rede'))
          }
        })
      })
    },
    inserirPostoMatriz ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redesDao.postoMatriz(state.headers, payload).then(response => {
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível inserir postos na rede'))
          }
        })
      })
    },
    detalhesRede ({ commit, state }, id) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        redesDao.detalhesRede(state.headers, id).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar redes'))
          }
          resolve(response.json())
        })
      })
    },
    removerDaRede ({ state }, payload) {
      return new Promise((resolve, reject) => {
        redesDao.removerDaRede(state.headers, payload).then(response => {
          if (response.ok) {
            resolve('Inserido com sucesso')
          }
          return response.text()
        }).then(error => {
          reject(error)
        })
      })
    },
    listarNoticias ({ commit, state }, id) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        redesDao.listarNoticias(state.headers, id)
          .then(response => {
            if (!response.ok) {
              reject(new Error('Não foi possível listar notícias'))
              return
            }
            return response.json()
          })
          .then(json => {
            const list = Array.isArray(json) ? json : (json.results || json)
            resolve(list)
          })
          .catch(() => {
            commit('setLoading', false)
            reject(new Error('Erro ao listar notícias'))
          })
      })
    },
    salvarNoticia ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto) {
          reject(new Error('Posto não selecionado'))
          return
        }
        const redeField = state.posto.rede
        const idRede = state.posto.id_rede ||
                       state.posto.rede_id ||
                       (redeField && typeof redeField === 'object' ? redeField.id : redeField) ||
                       null
        const body = { ...payload }
        if (idRede && !body.id_rede) body.id_rede = idRede
        if (body.id === null || body.id === undefined) {
          delete body.id
        }

        const call = body.id
          ? redesDao.atualizarNoticia(state.headers, body.id, body)
          : redesDao.cadastrarNoticias(state.headers, body)

        call.then(response => {
          if (!response || !response.ok) {
            return response && response.text
              ? response.text().then(t => Promise.reject(new Error(t || 'Erro ao salvar notícia')))
              : Promise.reject(new Error('Erro ao salvar notícia'))
          }
          return response.json()
        }).then(json => {
          resolve(json)
        }).catch(err => {
          commit('setLoading', false)
          reject(err)
        })
      })
    },
    deletarNoticia ({ commit, state }, id) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        redesDao.deletarNoticia(state.headers, id).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível deletar notícia'))
          }
        })
      })
    },
    transferirPosto ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.transferirPosto(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('ok')
          }
          reject(new Error('Não foi possível transferir posto'))
        }).catch(() => {
          reject(new Error('Não foi possível transferir posto'))
        })
      })
    },
    solicitacoesDeTransferencia ({
      commit,
      state
    }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.solicitacoesDeTransferencia(state.headers).then(response => {
          commit('setLoading', false)
          return response.json()
        }).then(json => {
          commit('setSolicitacoes_transferencia', json)
          resolve(json)
        }).catch(error => {
          reject(error)
        })
      })
    },
    deletarRede ({ state }, id) {
      return new Promise((resolve, reject) => {
        redesDao.deletarRede(state.headers, id).then(response => {
          if (response.ok) {
            resolve('ok')
          } else {
            reject(new Error('Não foi possível deletar rede.'))
          }
        })
      })
    },
    responderSolicitacaoTransferencia ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.responderSolicitacao(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('ok')
          }
          reject(new Error('Não foi possível transferir posto'))
        }).catch(() => {
          reject(new Error('Não foi possível transferir posto'))
        })
      })
    },
    relatorioVouchersEmpresa ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto) {
          return
        }
        postosDao.relatorioVouchersEmpresa(payload.filtro, state.posto.cnpj, state.headers, payload.pagination).then(response => {
          commit('setLoading', false)
          resolve(response.json())
        }).catch(() => {
          reject(new Error('Não foi possível carregar relatório'))
        })
      })
    },
    relatorioPix ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!state.posto) {
          return
        }
        postosDao.relatorioPix(payload, state.posto.cnpj, state.headers).then(response => {
          commit('setLoading', false)
          resolve(response.json())
        }).catch(() => {
          reject(new Error('Não foi possível carregar relatório'))
        })
      })
    },
    empresaComProposta ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        empresaDao.empresaComProposta(state.headers, payload).then(response => {
          commit('setLoading', false)
          resolve(response.json())
        }).catch(() => {
          commit('setLoading', false)
          reject(new Error('Não foi possível carregar empresas'))
        })
      })
    },
    programaIncentivo ({ state }, payload) {
      return new Promise((resolve, reject) => {
        postosDao.programaIncentivo(state.headers, payload).then(response => {
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          } else {
            resolve('ok')
          }
        })
      })
    },
    programaDeFidelidade ({ state }, payload) {
      return new Promise((resolve, reject) => {
        postosDao.programaDeFidelidade(state.headers, state.posto.cnpj, payload).then(response => {
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          } else {
            this.dispatch('escolherPosto', state.posto)
            resolve('ok')
          }
        })
      })
    },
    cadastrarMeioRecebimento ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        postosDao.cadastrarMeioRecebimento(state.headers, state.posto.cnpj, payload).then(response => {
          if (!response.ok) {
            reject(new Error('Não foi possível cadastrar meio de recebimento'))
          }
          resolve('cadastrado com sucesso')
        })
      })
    },
    pegarMeioRecebimento ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        postosDao.pegarMeioRecebimento(state.headers, state.posto.cnpj).then(response => {
          if (!response.ok) {
            reject(new Error('Não foi possível pegar os meios de recebimento'))
          }
          return response.json()
        }).then(json => {
          commit('setMeiosRecebimento', json)
          resolve(json)
        })
      })
    },
    deletarMeioRecebimento ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        postosDao.deletarMeioRecebimento(state.headers, state.posto.cnpj, payload).then(response => {
          if (!response.ok) {
            reject(new Error('Não foi possível deletar meio de recebimento'))
          }
          resolve('deletado com sucesso')
        })
      })
    },
    ativarSmartlock ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.smartLock(state.headers, state.posto.cnpj).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          this.dispatch('carregarPerfil')
          resolve('OK')
        })
      })
    },
    detalhesFaturamento ({
      commit,
      state
    }, id) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        faturamentoDao.info(id, state.posto.cnpj, state.headers).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            return response.json()
          } else {
            reject(response)
          }
        }).then(json => {
          resolve(json)
        })
      })
    },
    temBloqueio ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        payload.posto = state.posto.cnpj
        empresaDao.PegarBloqueio(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Algo deu errado'))
          }
          resolve(response.json())
        })
      })
    },
    BloqueioEmpresa ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        payload.posto = state.posto.cnpj
        empresaDao.Bloqueio(state.headers, payload).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          resolve('OK')
        })
      })
    },
    rejeitarProposta ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        payload.cnpj = state.posto.cnpj
        propostasDao.rejeitarProposta(payload, state.headers).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível realizar operação'))
          }
          this.dispatch('buscarPropostasDoPosto')
          resolve('OK')
        })
      })
    },
    pegarCarteiraVirtual ({ state, commit }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.pegarCarteiraVirtual(state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Carteira Apetrus não localizada.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    criarCarteiraVirtual ({ state, commit }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.criarCarteiraVirtual(state.posto.cnpj, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Carteira Apetrus não pôde ser criada.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    pegarHistoricoDaCarteiraVirtual ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.pegarHistoricoDaCarteiraVirtual(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          }
        })
      })
    },
    solicitarRetiradaDeSaldo ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.solicitarRetiradaDeSaldo(state.posto.cnpj, state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('200')
          } else {
            reject(new Error('Transação não sucedida.'))
          }
        })
      })
    },
    cadastrarChavePix ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        clientesDao.cadastrarChavePix(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('200')
          } else {
            reject(new Error('Transação não sucedida.'))
          }
        })
      })
    },
    getPostosAtivos ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.getPostosAtivos(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Transação não sucedida.'))
          }
        })
      })
    },
    getEmpresasAtivas ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        empresaDao.getEmpresasAtivas(state.headers, payload.filtros).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Transação não sucedida.'))
          }
        })
      })
    },
    getClientesFiltrados ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        clientesDao.getClientesFiltrados(payload.filtros, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Transação não sucedida.'))
          }
        })
      })
    },
    transferirSaldo ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.transferirSaldo(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('OK')
          } else {
            reject(new Error('Ocorreu um erro ao transferir saldo'))
          }
        })
      })
    },
    recebimentoCarteira ({ commit, state }, isEmpresa) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        const funcao = isEmpresa ? postosDao.recebimentoEmpresas : postosDao.recebimentoClientes
        funcao(state.posto.cnpj, state.headers).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('OK')
          } else {
            reject(new Error('Ocorreu um erro ao transferir saldo'))
          }
        })
      })
    },
    alterarTipoDesconto ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.alterarTipoDesconto(state.posto.cnpj, state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            this.dispatch('escolherPosto', state.posto)
            resolve('OK')
          } else {
            reject(new Error('Ocorreu um erro ao tentar realizar operação.'))
          }
        })
      })
    },
    assinatura ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        assinaturaDao.post(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            response.json().then(json => {
              resolve(json['mensagem'])
            })
          } else {
            response.json().then(json => {
              reject(new Error(json['mensagem']))
            })
          }
        })
      })
    },
    deletarAssinatura ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        assinaturaDao.deletar(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('OK')
          } else {
            reject(new Error('Ocorreu um erro ao tentar realizar operação.'))
          }
        })
      })
    },
    pegarPlanos ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        assinaturaDao.get(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Ocorreu um erro ao tentar realizar operação.'))
          }
        })
      })
    },
    pegarConveniados ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        conveniosDao.pegarConveniados(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Ocorreu um erro ao tentar realizar operação.'))
          }
        })
      })
    },
    detalharConvenio ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        conveniosDao.detalhar(state.headers, state.posto.cnpj, payload.id).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Não foi possível encontrar convênio'))
          }
        })
      })
    },
    frentistas ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        frentistaDao.get(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Não foi possível pegar frentistas'))
          }
        })
      })
    },
    editarFrentista ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        frentistaDao.put(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            return response.json()
          } else {
            reject(new Error('Não foi possível editar frentistas'))
          }
        }).then(json => {
          commit('changeFrentistas', json)
          resolve(json)
        })
      })
    },
    pegarComprasCashPosto ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        compraDao.pegarComprasCashPosto(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar compras de cash.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    transacoesPagPixBank ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!payload || !payload.method) reject(new Error('Method não enviado'))
        pagPixBankDao.transacoes(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Ocorreu um erro.'))
          } else {
            return response.json()
          }
        }).then(json => {
          commit('setLoading', false)
          resolve(json)
        })
      })
    },
    verificarTelefone ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoasDao.verificarTelefone(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Algo deu errado'))
          }
        })
      })
    },
    atualizarPagamentoExtra ({
      commit,
      state
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pagamentosExtra.atualizar(
          state.headers,
          payload
        ).then(response => {
          commit('setLoading', false)
          if (response.ok) {
            this.dispatch('carregarPagamentosExtra')
            this.dispatch('carregarPagamentosSecundarios')
            resolve('Ok')
          } else {
            reject(new Error('Não foi possível atualizar o meio de pagamento'))
          }
        })
      })
    },
    pegarCoordenadasGoogle ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        coordenadas.getCoordenadasGoogle(
          payload.logradouro,
          payload.numero,
          payload.bairro,
          payload.cidade,
          payload.estado
        ).then(response => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar coordenadas'))
          }
          return response.json()
        }).then(json => {
          commit('setLoading', false)
          if (json.results.length === 0) {
            reject(new Error('Não foi possível pegar coordenadas'))
          }
          if (payload.retornar_tudo) {
            resolve(json.results)
          }
          resolve({
            latitude: json.results[0].geometry.location.lat,
            longitude: json.results[0].geometry.location.lng
          })
        }).catch((e) => {
          console.log(e)
          commit('setLoading', false)
          reject(new Error('Não foi possível pegar coordenadas'))
        })
      })
    },
    async pegarCoordenadas ({ commit }, payload) {
      commit('setLoading', true)
      const response = await coordenadas.getCoordenadas(
        payload.logradouro,
        payload.numero,
        payload.bairro,
        payload.cidade,
        payload.estado
      )
      commit('setLoading', false)
      if (!response.ok) {
        const retorno = await this.dispatch('pegarCoordenadasGoogle', payload)
        return retorno
      }

      const json = await response.json()
      commit('setLoading', false)
      if (json.length === 0) {
        const retorno = await this.dispatch('pegarCoordenadasGoogle', payload)
        return retorno
      }
      if (payload.retornar_tudo) {
        return json
      }
      return {
        latitude: json[0].lat,
        longitude: json[0].lon
      }
    },
    pegarCarteirasVirtuais ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        carteiraVirtualDao.todas(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve(response.json())
          } else {
            reject(new Error('Algo deu errado'))
          }
        })
      })
    },
    editarPosto ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        postosDao.atualizar(state.headers, state.posto.cnpj, payload).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            commit('setPosto', { ...state.posto, ...payload })
            resolve('OK')
          } else {
            reject(new Error('Algo deu errado'))
          }
        })
      })
    },
    itens ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        itemDao
          .item(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              if (payload.method === 'GET') reject(new Error('Não foi possível pegar itens'))
              else if (payload.method === 'POST') reject(new Error('Não foi possível cadastrar item'))
              else if (payload.method === 'PUT') reject(new Error('Não foi possível atualizar item'))
              else if (payload.method === 'DELETE') reject(new Error('Não foi possível desativar item'))
            }
            if (payload.method === 'DELETE') resolve('ok')
            else {
              resolve(response.json())
            }
          })
      })
    },
    pegarCategorias ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        categoriaDao
          .get(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível pegar itens'))
            }
            resolve(response.json())
          })
      })
    },
    deletarArquivoFirebase ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        const storageRef = firebase.storage().refFromURL(payload).delete()
        storageRef.then(() => {
          resolve('Arquivo deletado com sucesso!')
        }).catch((error) => {
          console.error(error)
          reject(error)
        })
      })
    },
    cadastrarMuitosCombustiveis ({
      commit,
      state
    }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        postosDao.precificarPosto(
          state.headers,
          payload
        ).then((response) => {
          commit('setLoading', false)
          if (response.ok) {
            resolve('OK')
          } else {
            reject(new Error('Não foi possível cadastrar preços'))
          }
        })
      })
    },
    premios ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        premioDao
          .allMethods(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              if (payload.method === 'GET') reject(new Error('Não foi possível pegar prêmios'))
              else if (payload.method === 'POST') reject(new Error('Não foi possível cadastrar prêmio'))
              else if (payload.method === 'PUT') reject(new Error('Não foi possível atualizar prêmio'))
              else if (payload.method === 'DELETE') reject(new Error('Não foi possível desativar prêmio'))
            }
            if (payload.method === 'DELETE') resolve('ok')
            else {
              return response.json()
            }
          }).then(json => {
            commit('setPremios', json)
            resolve(json)
          })
      })
    },
    limiteDeCompra ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */

      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        compraDao.limite(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) reject(new Error('Ocorreu um erro'))

            if (payload.method !== 'DELETE') resolve(response.json())
            resolve('OK')
          })
      })
    },
    provedorSMTP ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        provedorSMTPDao.gerenciar(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) reject(new Error('Ocorreu um erro'))
          if (payload.method === 'POST' || payload.method === 'DELETE') {
            this.dispatch('escolherPosto', state.posto)
          }
          if (payload.method !== 'DELETE') resolve(response.json())
          resolve('OK')
        })
      })
    },
    ofertas ({ commit, state }, payload) {
      /*
        Usada para GET, DELETE, PUT e POST
      */
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        ofertasDao.gerenciar(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) reject(new Error('Ocorreu um erro'))
          if (payload.method === 'GET') resolve(response.json())
          resolve('OK')
        })
      })
    },
    pegarVendasDeAssinatura ({ commit, state }, payload) {
      commit('setLoading', true)
      payload = payload || {}
      payload.posto = state.posto.cnpj
      return new Promise((resolve, reject) => {
        compraDao.deAssinatura(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar compras de assinatura.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    verificarOferta ({ commit, state }, payload) {
      commit('setLoading', true)
      payload = payload || {}
      payload.posto = state.posto.cnpj
      return new Promise((resolve, reject) => {
        ofertasDao.verificarPadrao(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar ofertas.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    sendWhatsappVerification ({ commit, state }) {
      commit('setLoading', true)
      const payload = {
        'celular': state.pessoa.telefone
      }
      return new Promise((resolve, reject) => {
        sendzapiDao
          .enviarCodigo(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response)
            } else {
              reject(new Error('Não foi possivel enviar o codigo'))
            }
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    confirmWhatsappVerification ({ commit, state }, payload) {
      commit('setLoading', true)
      const codigo = {
        'codigo': payload
      }
      return new Promise((resolve, reject) => {
        sendzapiDao
          .confirmarCodigo(codigo, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              localStorage.setItem(`${state.user ? state.user.id : undefined}/dispositivoAutenticado`, true)
              resolve(true)
            } else {
              reject(new Error('Não foi possível confirmar o código do WhatsApp'))
            }
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(error)
          })
      })
    },
    verificarConvenios ({ commit, state }, payload) {
      commit('setLoading', true)
      payload = payload || {}
      payload.posto = state.posto.cnpj
      return new Promise((resolve, reject) => {
        conveniosDao.verificarPadrao(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar convenios.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    buscarAvaliacoesFrentista ({ state }, frentista) {
      return new Promise((resolve, reject) => {
        if (!state.posto || !state.posto.cnpj) {
          reject(new Error('Posto não selecionado'))
          return
        }
        frentistaDao.avaliacaoFrentista(state.posto.cnpj, frentista.id_frentista, state.headers)
          .then(response => {
            if (!response.ok) {
              reject(new Error('Não foi possível buscar avaliações'))
            } else {
              return response.json()
            }
          })
          .then(json => {
            resolve(json)
          })
          .catch(err => reject(err))
      })
    },
    aumentarLimiteDeCompra ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        assinaturaDao.aumentarLimite(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (response.ok) {
              resolve(response.json())
            } else {
              response.json().then(err => {
                reject(new Error(err.erro || 'Erro ao atualizar limite de compra.'))
              }).catch(() => {
                reject(new Error('Erro ao atualizar limite de compra.'))
              })
            }
          })
          .catch((error) => {
            commit('setLoading', false)
            reject(new Error(error.message || 'Erro de comunicação com servidor.'))
          })
      })
    }
  },
  getters: {
    consolidacao (state) {
      return state.consolidacao
    },
    headers (state) {
      return state.headers
    },
    user (state) {
      return state.user
    },
    pessoa (state) {
      return state.pessoa
    },
    posto (state) {
      return state.posto
    },
    precos (state) {
      return state.posto ? state.posto.precos : []
    },
    postos (state) {
      return state.postos
    },
    compras (state) {
      return state.compras
    },
    total_relatorio_compras (state) {
      return state.total_relatorio_compras
    },
    compras_no_posto (state) {
      return state.compras_no_posto
    },
    total_relatorio_compras_posto (state) {
      return state.total_relatorio_compras_no_posto
    },
    vouchers (state) {
      return state.vouchers
    },
    total_relatorio_vouchers (state) {
      return state.total_relatorio_vouchers
    },
    combustiveis (state) {
      return state.combustiveis
    },
    combustiveisSilenciados (state) {
      return state.combustiveisSilenciados
    },
    frentistas (state) {
      return state.frentistas
    },
    maquinetas (state) {
      return state.maquinetas
    },
    versoes (state) {
      return state.versoes
    },
    tiposMaquineta (state) {
      return state.tiposMaquineta
    },
    tiposPagamento (state) {
      return state.tiposPagamento
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    lastPage (state) {
      return state.lastPage
    },
    endereco (state) {
      return state.endereco
    },
    fotoPerfil (state) {
      return state.fotoPerfil
    },
    imagemLogo (state) {
      return state.imageLogo
    },
    automacoes (state) {
      return state.automacoes
    },
    automacao (state) {
      return state.automacao
    },
    politicasDePrivacidade (state) {
      return state.politicasDePrivacidade
    },
    termosDeUso (state) {
      return state.termosDeUso
    },
    propostas (state) {
      return state.propostas
    },
    recargas_propostas (state) {
      return state.recargas_propostas
    },
    pagamentosExtra (state) {
      return state.pagamentosExtra
    },
    pagamentosSecundarios (state) {
      return state.pagamentosSecundarios
    },
    convenios (state) {
      return state.convenios
    },
    faturas (state) {
      return state.faturas
    },
    timer (state) {
      return state.timer
    },
    smartLock (state) {
      return state.smartLock
    },
    link (state) {
      return `${settings.apetrusGo}/${state.posto.cnpj}/`
    },
    clientes (state) {
      return state.clientes
    },
    premios (state) {
      return state.premios
    },
    hasNewVersion (state) {
      return state.hasNewVersion
    },
    versao (state) {
      return state.versao
    },
    redes (state) {
      return state.redes
    },
    naologar (state) {
      return state.naologar
    },
    solicitacoes_transferencia (state) {
      return state.solicitacoes_transferencia
    },
    ofertas (state) {
      return state.ofertas
    },
    countCliente (state) {
      return state.countCliente
    },
    meios_recebimento (state) {
      return state.meios_recebimento
    },
    drawer (state) {
      return state.drawer
    }
  }
})
